export enum Role {
  Admin = "Admin",
  Office = "Office",
  Director = "Director",
  SampleTaker = "SampleTaker",
  Supplier = "Supplier",
  Laboratory = "Laboratory",
  LaboratoryPlus = "LaboratoryPlus",
  Student = "Student",
  StudentPlus = "StudentPlus",
  LaboratoryManagement = "LaboratoryManagement",
}

export const RoleList = [
  Role.Admin,
  Role.Office,
  Role.Director,
  Role.SampleTaker,
  Role.Supplier,
  Role.Laboratory,
  Role.LaboratoryPlus,
  Role.Student,
  Role.StudentPlus,
  Role.LaboratoryManagement,
];
